import getConfig from 'next/config';
import type { AxiosResponse } from 'axios';

import { donedealServerGateway } from '../api/api-utils/commonApiUtils';

import {
  AreasResponse,
  AreasAutocompleteResponse,
} from '../api/types/areasApiTypes';

const {
  publicRuntimeConfig: { API_CLIENT_TIMEOUT },
} = getConfig();

async function getAreasAutocomplete(
  term: string,
  county = '',
): Promise<AxiosResponse<AreasAutocompleteResponse>> {
  const response: AxiosResponse<AreasAutocompleteResponse> =
    await donedealServerGateway.get(
      `/ddapi/v1/areas/autocomplete?${
        county ? `county=${county}&` : ''
      }query=${term}`,
      {
        timeout: parseInt(API_CLIENT_TIMEOUT),
      },
    );

  return response;
}

async function getAreas(
  county: string,
): Promise<AxiosResponse<AreasResponse[]>> {
  const response: AxiosResponse<AreasResponse[]> =
    await donedealServerGateway.get(`ddapi/v1/areas/${county}`, {
      timeout: parseInt(API_CLIENT_TIMEOUT),
    });

  return response;
}

export const areasApi = {
  getAreas,
  getAreasAutocomplete,
};
